export const serviceProviderConceptTabsQueryParamName = 'tab'

export const serviceProviderConceptTabs = {
  overview: 'overview',
  initiatives: 'initiatives',
  discussion: 'discussion',
} as const
